import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const SidebarItem = ({ to, icon, label }) => (
  <NavLink to={to} className="my-8 cursor-pointer">
    <div className="flex items-center py-[10px] px-2">
      <div className="mt-2">{icon}</div>
      <p className="text-[16px] ml-2">{label}</p>
    </div>
  </NavLink>
);

function SideBar() {

   const baseUrl1 =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV1
      : process.env.REACT_APP_BASE_URL_PROD1;
  const [navpopup, setNavpopup] = useState(false);
  const Navref = useRef(null);

  const handleOutsideClick = (event) => {
    if (Navref.current && !Navref.current.contains(event.target)) {
      Closenav();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const OpenNav = () => {
    setNavpopup(true);
    document.body.classList.add("popup-open");
  };

  const Closenav = () => {
    setNavpopup(false);
    document.body.classList.remove("popup-open");
  };

  const handleLogout = () => {
    console.log("Logging out...");
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      {/* Sidebar for larger screens */}
      <div className="sidebar fixed top-0 left-0 w-[200px] lg:w-[265px] hidden lg:block h-screen bg-[#2A668D]">
        <Link to={"/"}>
          <p className="text-[24px] text-white px-3 py-5 cursor-pointer font-bold">
            We Help You First
          </p>
        </Link>

        <nav className="text-white">
          <ul className="px-2">
            <SidebarItem
              to="/admin"
              label="Dashboard"
              icon={<span className="material-symbols-outlined">grid_view</span>}
            />
            <SidebarItem
              to="/admin/customer"
              label="Customers"
              icon={<span className="material-symbols-outlined">account_circle</span>}
            />
            <SidebarItem
              to="/admin/vendor"
              label="Vendors"
              icon={<span className="material-symbols-outlined">business_center</span>}
            />
            <SidebarItem
              to="/admin/report"
              label="Reports"
              icon={<span className="material-symbols-outlined">receipt</span>}
            />
            <SidebarItem
              to="/admin/useraccount"
              label="User Accounts"
              icon={<span className="material-symbols-outlined">receipt</span>}
            />
            <SidebarItem
              to="/admin/zone"
              label="Zone"
              icon={<span className="material-symbols-outlined">receipt</span>}
            />
            
            <SidebarItem
              to="/admin/services"
              label="Services"
              icon={<span className="material-symbols-outlined">leaderboard</span>}
            />


            <SidebarItem
              to="/admin/settings"
              label="Settings"
              icon={<span className="material-symbols-outlined">settings</span>
              }
            />

<SidebarItem
              to="/admin/booking"
              label="Bookings"
              icon={<span className="material-symbols-outlined">settings</span>
              }
            />

          </ul>
        </nav>
      </div>

      {/* Mobile Navbar */}
      <div className="flex absolute top-0 w-full p-2 border items-center justify-between h-[70px] lg:hidden">
  {/* Logo / Homepage link */}
  <Link to={"/"} aria-label="Homepage">
    <p className="text-[14px] sm:text-[16px] md:text-[18px] text-[#2A668D] vol lg:px-3 cursor-pointer">
      We Help You First
    </p>
  </Link>

  {/* Hamburger Menu Button */}
  <button
    onClick={OpenNav}
    className="text-[#2A668D] text-[24px] sm:text-[26px] md:text-[28px] px-3 py-2"
    aria-label="Open navigation"
  >
    <span className="material-symbols-outlined">menu</span>
  </button>

  {/* Mobile Nav Popup */}
  {navpopup && (
    <div className="absolute top-0 left-0 h-screen w-full bg-[#000000] bg-opacity-[50%] z-20">
      <div className="relative">
        {/* Mobile Sidebar Navigation */}
        <div
          ref={Navref}
          className="absolute right-0 w-[75%] md:w-[50%] h-screen bg-[#2A668D] p-5 overflow-y-auto"
        >
          <button
            onClick={Closenav}
            className="absolute top-5 right-5 text-white text-[30px]"
            aria-label="Close navigation"
          >
            <span className="material-symbols-outlined">close</span>
          </button>

          {/* Menu Items */}
          <ul className="text-[#ffffff] mt-10">
            {[{ to: "/admin", icon: "grid_view", label: "Dashboard" },
              { to: "/admin/customer", icon: "account_circle", label: "Customers" },
              { to: "/admin/vendor", icon: "business_center", label: "Vendor" },
              { to: "/businesslisting", icon: "storefront", label: "Business Listing" },
              { to: "/admin/services", icon: "leaderboard", label: "Leads" },
              { to: "/admin/report", icon: "receipt", label: "Reports" },
            ].map(({ to, icon, label }) => (
              <NavLink key={to} to={to} activeClassName="text-[#fff] bg-[#27648B]">
                <li className="my-6 cursor-pointer">
                  <div className="flex items-center py-2 px-2">
                    <span className="material-symbols-outlined text-[#fff]">{icon}</span>
                    <p className="text-[14px] sm:text-[16px] ml-2">{label}</p>
                  </div>
                </li>
              </NavLink>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )}
</div>


    </>
  );
}

export default SideBar;
